import { useMemo, useState } from 'react';
import { chefPlating, Modal, PrimaryButton, SecondaryButton, Typography } from '@weareopenr/component-library';
import { useForm } from 'react-hook-form';
import { TEditVenueOpeningTimes } from './types';
import { VenueOpeningTimes } from '../VenueOpeningTimes/VenueOpeningTimes';
import styles from './VenueOpeningTimeEditModal.module.scss';

import { IVenue } from 'src/types/venue.types';
import { useUpdateVenueOpeningTimes } from 'src/hooks/useUpdateVenueOpeningTimes/useUpdateVenueOpeningTimes';
import createOpeningTimes from './utilities/createOpeningTimes';

interface IVenueOpeningTimesEditForm {
  onModalClose: () => void;
  venue: IVenue;
}

interface IVenueOpeningTimesEditModal extends IVenueOpeningTimesEditForm {
  isModalOpen: boolean;
}

const VenueOpeningTimeEditForm = ({ venue, onModalClose }: IVenueOpeningTimesEditForm) => {
  const [deletedOpeningTimes, setDeletedOpeningTimes] = useState<string[]>([]);
  const { venueId } = venue;
  const { mutate, isLoading: isUpdateLoading } = useUpdateVenueOpeningTimes(venueId, onModalClose);

  const initialValues = useMemo(() => createOpeningTimes(venue?.openingTimes), [venue]);

  const formFields = useForm<TEditVenueOpeningTimes>({
    defaultValues: initialValues,
    mode: 'onChange',
  });

  const {
    handleSubmit,
    formState: { dirtyFields, isSubmitting },
  } = formFields;
  const onDelete = (idsCollection: string[]) => {
    setDeletedOpeningTimes([...deletedOpeningTimes, ...idsCollection]);
  };

  const onSubmit = (data: TEditVenueOpeningTimes) => {
    mutate({ data, deletedOpeningTimes, dirtyFields });
  };

  return (
    <div className={styles['form-content']}>
      <Typography size="xxlarge" weight="semi-bold" className={styles['title-container']}>
        Edit Opening times for {venue.name}
      </Typography>

      <form onSubmit={handleSubmit(onSubmit)} id="venue-opening-times-form" aria-label="venue-opening-times-form">
        <VenueOpeningTimes formFields={formFields} onDelete={onDelete} />
        <div className={styles['cta-container']}>
          <SecondaryButton type="button" size="full-width" buttonStyle="outline" onClick={onModalClose}>
            Back
          </SecondaryButton>
          <PrimaryButton loading={isSubmitting || isUpdateLoading} size="full-width" type="submit">
            Save
          </PrimaryButton>
        </div>
      </form>
    </div>
  );
};

const VenueOpeningTimeEditModal = ({ isModalOpen, onModalClose, venue }: IVenueOpeningTimesEditModal) => {
  return (
    <Modal image={chefPlating} open={isModalOpen} closeModal={onModalClose} contentPosition="top">
      <VenueOpeningTimeEditForm onModalClose={onModalClose} venue={venue} />
    </Modal>
  );
};

export default VenueOpeningTimeEditModal;
